<template>
  <div class="mentor_content_component">
    <member-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                        :areaList="areaList"></member-filter-link>
    <member-empty-link :emptyLayout="emptyLayout" v-if="List.length===0"></member-empty-link>
    <member-list-link :memberData="List" :listLayout="listLayout" v-else></member-list-link>
    <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                     :listLength="List.length"></pagination-link>
  </div>
</template>

<script>
import MemberFilterLink from "@/components/member/MemberFilterLink";
import MemberEmptyLink from "@/components/member/MemberEmptyLink";
import PaginationLink from "@/components/member/PaginationLink";
import MemberListLink from "@/components/member/MemberListLink";
import listMixins from "@/mixins/listMixins";
import filterMixins from "@/mixins/filterMixins";
import memberUtil from "@/components/member/memberUtil";
import alertMixins from "@/mixins/alertMixins";

const {filterConfig} = memberUtil;

export default {
  name: "MemberListComponent",
  mixins: [filterMixins, listMixins, memberUtil, alertMixins],
  components: {MemberEmptyLink, MemberFilterLink, PaginationLink, MemberListLink},
  inject: [],
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
      memberListSetData: this.setData,
    }
  },
  props: {
    memberType: '',
  },
  data() {
    return {
      listLayout: '',
      emptyLayout: '',
      filterLayout: '',
      paginationLayout: '',
      getFunc: '',
      pageRow: 0,
      listApiParamSet: {},
      filterData: {},
      areaList:{}
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.setFilterConfig(filterConfig)
    this.initConfig()
    this.setParserType('url', this.$route.fullPath);
  },
  mounted() {
    this.getList(true)
    this.getAreaList();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    initConfig() {
      let memberConfig = this.returnMemberConfig(this.memberType);
      this.listLayout = memberConfig.listLayout;
      this.filterLayout = memberConfig.filterLayout;
      this.paginationLayout = memberConfig.paginationLayout;
      this.emptyLayout = memberConfig.emptyLayout;

      this.getFunc = memberConfig.getFunc;
      this.listApiParamSet = memberConfig.listApiParamSet;
      this.pageRow = memberConfig.pageRow;


      if (memberConfig.pageRow && memberConfig.pageRow != this.filterSet.page.size) {
        this.pageRow = memberConfig.pageRow;
        this.filterSet.page.size = memberConfig.pageRow;
        this.pageClass.setterPage('size', this.pageRow);
      }

      let listOptions = {
        url: this.$api.$member[this.getFunc],
        defaultParams: this.listApiParamSet,
      }
      this.initList('api', listOptions);
    },
    setData(key, value) {
      this[key] = value;
    },
    getAreaList() {
      let params = {si: 1}
      try {
        this.$api.$area.getArea(params).then(res => res.Data.Result).then(res => {
          let type = this.returnAreaType(res.Info.type)
          if (type === true) {
            let Allarea = {
              ac_idx: '',
              is_city_name: '전체'
            }
            res.List.unshift(Allarea);
            this.areaList = res.List
          } else {
            this.errorAlert(type)
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    returnAreaType(type) {
      switch (type) {
        case 1:
          return true
        default:
          return '지역 리스트를 불러올 수 없습니다.'
      }
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>